import React from 'react';

function HowToPlayContent() {
    return (
      <div>
        <p>In Inkognito, everyone takes turns to collaborate on drawing a random subject. That is, everyone except for an impostor artist who is trying to play along without revealing their role.</p>
        <p>With only a few strokes, contribute enough to a drawing to convince others that you are not an impostor, but don't add enough to the drawing to reveal the subject of the drawing and give it away to the real impostor!</p>
      </div>
    );
}

export default HowToPlayContent;
